export const environment = {
    production: false,
    baseurl: 'https://apim-np-t-idb-integration.iadb.org/ext/api/eaps/v2',
    redirecturl: 'https://externalaccounts-t.iadb.org',
    postlogouturl: 'https://externalaccounts-t.iadb.org',
    Name: 'eaps-a-np-t',
    tenant: 'idbgextt',
    tenantId: '1f87f52a-35d7-4344-9c79-095847954509',
    clientId: '247a849a-7df7-4919-a228-e63ac74ae200',
    clientScopesId: '56e5af18-3638-4d86-84df-2444dfbd2b37',
    subscriptionKey: '6addb2fe17f54f1aa750988c9ac96297',
    isDarkMode: false,
};
